import { registerPlugin } from '@capacitor/core'
import {
  BackgroundGeolocationPlugin,
  Location as BGPosition,
} from '@capacitor-community/background-geolocation'
import { GeolocationAdapterReturn, BGWatcherIDString } from '../types/adapters'

const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>('BackgroundGeolocation')

export const backgroundGeolocationAdapter = (): GeolocationAdapterReturn => {
  const getGPSPosition = async (
    timeout?: number | undefined,
    useStaleData?: boolean
  ): Promise<BGPosition | null | void> => {
    const locationReturn = await getPosition(timeout, useStaleData)
      .catch((error) => console.error(error))
      .then((location) => location)

    return locationReturn
  }
  const addWatcher = (
    getLocations: (data: BGPosition) => void,
    getWatcherID: (id: BGWatcherIDString) => void
  ) => {
    BackgroundGeolocation.addWatcher(
      {
        backgroundMessage: 'Cancel to prevent battery drain.',
        requestPermissions: true,
        stale: false,
      },
      function success(res, error) {
        if (error) {
          if (
            error.code === 'NOT_AUTHORIZED' &&
            window.confirm(
              'This app needs your location, ' +
                'but does not have permission.\n\n' +
                'Open settings now?'
            )
          ) {
            void BackgroundGeolocation.openSettings()
          }
        }
        // Success retain GPS
        if (typeof res !== 'undefined') {
          getLocations(res)
        }
      }
    )
      .then((bgWatchID) => {
        getWatcherID(bgWatchID)
      })
      .catch((error) => console.error(error))
  }
  const removeWatcher = async (bgWatchID: BGWatcherIDString): Promise<void> => {
    BackgroundGeolocation.removeWatcher({ id: bgWatchID }).catch((error) => {
      console.error(`Error removing BGWatcher ${error}`)
    })
  }
  // Important to give sufficient time for coordinates, or android bugs arise
  const getPosition = async (timeout = 5000, useStaleData = false): Promise<BGPosition> => {
    let id: string | null = null
    return new Promise((resolve) => {
      BackgroundGeolocation.addWatcher(
        {
          backgroundMessage: 'Cancel to prevent battery drain.',
          requestPermissions: true,
          stale: useStaleData,
        },
        function success(res, error) {
          if (error) {
            console.error(`Error getting position: ${error}`)
          }
          if (typeof res == 'undefined') {
            console.error('res is undefined')
          }
          if (typeof res !== 'undefined') {
            resolve(res)
          }
        }
      )
        .then((bgWatchID) => {
          id = bgWatchID
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setTimeout(() => {
            if (id) void BackgroundGeolocation.removeWatcher({ id: id })
          }, timeout)
        })
    })
  }

  return {
    getGPSPosition,
    addWatcher,
    removeWatcher,
  }
}
